import React, { useState } from "react";
import BranchAuth from "./BranchAuth";
import AddEditBranchAuth from "./AddEditBranchAuth";
import AddEditBranchAuthDetails from "./AddEditBranchAuthDetails";

const BranchAuthorization = () => {
    const [authMatrixHeadId, setauthMatrixHeadId] = useState("");

    const handleAddEditAuthMatrix = async (res) => {
        setauthMatrixHeadId(res?.data?.authMatrixHeadId);
    };

    console.log("authMatrixHeadId idhr", authMatrixHeadId);
    return (
        <div>
            <AddEditBranchAuth handleAddEditAuthMatrix={handleAddEditAuthMatrix} />
            <AddEditBranchAuthDetails authMatrixHeadId={authMatrixHeadId} />
            <BranchAuth />
        </div>
    );
};

export default BranchAuthorization;
